var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseFilterWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.175 22a1.572 1.572 0 01-1.226-.581L.358 11.99a1.57 1.57 0 010-1.996L8.216.568a1.574 1.574 0 012.42 2.01l-7.025 8.423 6.79 8.422A1.57 1.57 0 019.175 22z",
    fill: "#fff"
  })));
}

export default SvgCloseFilterWindow;